<template>
  <div class="learn-container">
    <header class="container__header">
      <img src="./images/header-bg.png" alt="" class="container__header-bg">
      <slot name="header"></slot>
    </header>

    <main class="container__main">
      <!-- 左侧柱子 -->
      <aside class="main__aside">
        <img src="./images/aside-left-bg.png" class="main__aside-img_bg">
        <img src="./images/aside-left-board.png" class="main__aside-img_board" @click="handleGoBack">
        <img src="./images/aside-left-hand.png" class="main__aside-img_hand">
        <div class="l-left-post-board l-learn-img-info"></div>
      </aside>

      <!-- 主要内容 -->
      <section class="container__content">
        <slot></slot>
      </section>

      <!-- 右侧柱子 -->
      <aside class="main__aside">
        <img src="./images/aside-right-bg.png" class="main__aside-img_bg">
        <img src="./images/aside-right-board.png" class="main__aside-img_board right">
        <img src="./images/aside-right-hand.png" class="main__aside-img_hand right">
        <div class="l-right-post-board l-learn-img-info"></div>
      </aside>
    </main>

    <footer class="container__footer">
      <img src="./images/footer-bg.png" alt="" class="container__footer-bg">
      <img src="./images/footer-bg-small.png" alt="" class="container__footer-bg_small">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'LLearnContainer',
  methods: {
    handleGoBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="stylus" scoped>
.learn-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.container__header {
  width: 100%;
  opacity: 1;
  z-index: 10;
}
.container__header-bg {
  display: block;
  width: 100%;
}

.container__main {
  display: flex;
  justify-content: space-between;
  flex: 1;
  padding: 0 40px;
  margin: -50px 0
  overflow: hidden;
}
.main__aside {
  position: relative;
  z-index: 1;
}
.main__aside-img_bg {
  display: block;
  width: 180px;
  height: 100%;
}
.main__aside-img_board {
  position: absolute;
  left: 50%;
  top: 40px;
  transform: translateX(-60%);
  width: 80px;

  &.right {
    right: 50%;
    transform: translateX(-40%);
  }
}
.main__aside-img_hand {
  position: absolute;
  top: 50%;
  left: -4px;
  transform: translateY(-50%);
  width: 100px;

  &.right {
    left: auto;
    right: -4px;
  }
}
.container__content {
  width: 100%;
  margin: 0 -50px;
}


.container__footer {
  position: relative;
  width: 100%;
}
.container__footer-bg {
  display: block;
  width: 100%;
}
.container__footer-bg_small {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  height: 150px;
}
</style>